import type { NhomDoiSoat } from '@qlk/shared';

import { EmptyState, dinhDangTien } from '../../../ui/index.js';

export interface KhungTheoNhomProps {
  theoNhom: NhomDoiSoat[];
}

/**
 * Khung theo nhóm: thực nhận → chi phí → lợi nhuận → phần chia → công ty giữ.
 *
 * Mỗi khối là một nhóm; kênh chưa gán nhóm thành khối riêng ở cuối chứ không bị
 * bỏ ra, nếu không thì tổng theo nhóm hụt tiền so với tổng theo người.
 */
export function KhungTheoNhom({ theoNhom }: KhungTheoNhomProps) {
  if (theoNhom.length === 0) {
    return (
      <div className="rounded-the border border-vien bg-be-mat">
        <EmptyState
          title="Chưa có nhóm nào trong kỳ"
          description="Gán kênh vào nhóm ở trang Nhóm & đội ngũ để trưởng nhóm được chia theo từng kênh."
        />
      </div>
    );
  }

  const dong = (nhan: string, giaTri: number, am = false) => (
    <div className="flex items-baseline justify-between gap-3">
      <dt className="text-phu text-chu-mo">{nhan}</dt>
      <dd className={`tabular-nums text-co-ban ${am && giaTri < 0 ? 'text-bad-chu' : 'text-chu'}`}>
        {dinhDangTien(giaTri)}
      </dd>
    </div>
  );

  return (
    <div className="grid grid-cols-1 gap-4 @min-[700px]/noi-dung:grid-cols-2 @min-[1100px]/noi-dung:grid-cols-3">
      {theoNhom.map((n) => (
        <article
          key={n.teamId ?? 'chua-gan'}
          className="rounded-the border border-vien bg-be-mat p-6"
        >
          <header className="mb-3">
            <h3 className="text-tieu-de-khoi font-semibold text-chu">{n.tenNhom}</h3>
            <p className="text-phu text-chu-mo">{n.soKenh} kênh</p>
          </header>

          <dl className="space-y-2">
            {dong('Công ty thực nhận', n.thucNhan)}
            {dong('Chi phí vận hành', n.chiPhiVanHanh)}
            {dong('Lợi nhuận', n.loiNhuan, true)}
            {dong('Phần chia nhân sự', n.phanChia)}
            <div className="flex items-baseline justify-between gap-3 border-t border-vien pt-2">
              <dt className="text-phu font-medium text-chu-phu">Công ty giữ</dt>
              <dd
                className={`tabular-nums text-tieu-de-khoi font-bold ${
                  n.congTyGiu < 0 ? 'text-bad-chu' : 'text-chu'
                }`}
              >
                {dinhDangTien(n.congTyGiu)}
              </dd>
            </div>
          </dl>

          {n.congTyGiu < 0 && (
            <p className="mt-3 rounded-[10px] bg-warn-nen px-3 py-2 text-phu text-warn-chu">
              Công ty bù lỗ nhóm này trong kỳ: phần chia lớn hơn lợi nhuận.
            </p>
          )}
        </article>
      ))}
    </div>
  );
}
